import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useLeadSelector() {
  const LeadGridData = useSelector((state) => state.Lead.lead_grid?.leads) || []; // Lead Grid Data
  const LeadViewData = useSelector((state) => state.Lead.lead_view?.lead) || []; // Lead View
  const LeadListStatus = useSelector((state) => state.Lead.lead_list) || []; // Lead List status
  const LeadListAssignStatus = useSelector((state) => state.Lead.assign_status) || []; // Lead Assign status
  const BranchBankData = useSelector((state) => state.Lead.branchBankId) || []; //
  // console.log('BranchBankData', BranchBankData);
  const AppData =
    useSelector(
      (state) => state.Lead.app_data?.journeyConfigs?.journeyModel?.journeyReviewWizard
    ) || {}; // get application by id

  const LeadListStatusDrop = useMemo(
    () =>
      (LeadListStatus?.leadsStageStatuses || [])?.map((item) => ({
        label: item?.stageStatusName,
        value: item?.stageStatusId
      })),
    [LeadListStatus]
  );

  const BranchBankDrop = useMemo(
    () =>
      (BranchBankData || [])?.map((item) => ({
        label: item?.branchName,
        value: item?.branchId
      })),
    [BranchBankData]
  );

  const LeadListAssignStatusDrop = useMemo(
    () =>
      (LeadListAssignStatus || [])
        // ?.filter((item) => item?.stageStatusName?.toLowerCase() !== 'completed')
        ?.map((item) => ({
          label: item?.stageStatusName,
          value: item?.stageStatusId
        })),
    [LeadListAssignStatus]
  );

  return {
    LeadGridData,
    LeadViewData,
    LeadListStatusDrop,
    AppData,
    LeadListAssignStatusDrop,
    BranchBankDrop
  };
}
